var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 639,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 439,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 641,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 642,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 643,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2529;